<template>
    <section class="submittal-header">
        <div class="container">

        </div>
    </section>
</template>

<script>
    export default {
        name: 'seismic-header'

    }
</script>
